import { isBaseQueryParams } from "@/helpers/isBaseQueryParams";
import { QueryParamsBase } from "@/types/types";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getPaymentId, getPayments } from "./api";

export function usePayments(
  params?: QueryParamsBase,
  select?: string[],
  options?: object,
) {
  const isBaseQuery = isBaseQueryParams(params);

  const paramsQuery = isBaseQuery
    ? { current: params?.current, pageSize: params?.pagination?.pageSize }
    : params;

  const query = useQuery({
    queryKey: ["payments", { params: paramsQuery, select }],
    queryFn: () => getPayments({ ...paramsQuery, select }),
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
    ...options,
  });

  return { ...query };
}

export function usePaymentId(register_id: string, options?: object) {
  const query = useQuery({
    queryKey: ["payment", register_id],
    queryFn: () => getPaymentId(register_id),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 2,
    enabled: !!register_id,
    ...options,
  });

  return { ...query };
}
